/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
// Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
// External imports

// CUSTOM_LINKS is an array of "links" to be generated (where the school has
// specified a URL for the item in question).  To add a new one, put the icon
// into public/assets/images/premier-icons (including theme-based variations)
// and add an entry below.
const CUSTOM_LINKS = [
  {
    label: 'School Website',
    option: 'webSiteLink',
    icon: 'student',
  },
  {
    label: 'Policies and Procedures',
    option: 'policiesLink',
    icon: 'folder-open',
  },
  {
    label: 'School Shop',
    option: 'shopLink',
    icon: 'shopping-cart',
  },
  {
    label: 'Uniform Shop',
    option: 'uniformLink',
    icon: 't-shirt',
  },
  {
    label: 'Food',
    option: 'foodLink',
    icon: 'fork-knife',
  },
  {
    label: 'Newsletter',
    option: 'newsLink',
    icon: 'newspaper',
  },
  {
    label: 'Portal',
    option: 'portalLink',
    icon: 'globe',
  },
  {
    label: 'Library',
    option: 'libraryLink',
    icon: 'books',
  },
];

// SOCIAL_LINKS is an array of "links" to be generated (where the school has
// specified a URL for the item in question).  To add a new one, put the icon
// into public/assets/images/premier-icons (including theme-based variations)
// and add an entry below.
const SOCIAL_LINKS = [
  {
    label: 'Facebook',
    option: 'facebookLink',
    icon: 'facebook-logo',
  },
  {
    label: 'Instagram',
    option: 'instagramLink',
    icon: 'instagram-logo',
  },
  {
    label: 'X',
    option: 'twitterLink',
    customIcon: 'twitter-x-duotone',
  },
  {
    label: 'Hail',
    option: 'hailLink',
    customIcon: 'hail-duotone',
  },
];

export default class ParentAppHomeSchool extends Component {
  // school is the school for which this component is being rendered.
  school = null;

  // reportsHref is the URL for the school's reports list page.
  // Pass this in from the consuming app; if null, the Reports button is hidden.
  reportsHref = null;

  // schoolColor is the color passed in when initiating
  // the home page school menu
  // already dasherized and lowercased
  @tracked schoolColor = '';

  // hasOutstandingPayments shows a warning badge if there are any outstanding payments for any of the kids' accounts for the school
  hasOutstandingPayments = false;

  // headerClasses concatenates the school color and school classes
  // for the header color
  get headerClasses() {
    let classes = ['home-page__header'];
    if (isEmpty(this.schoolColor)) {
      // Do teal by default if no other specified
      classes.push('teal');
    } else {
      // Push the specified color
      classes.push(this.schoolColor);
    }
    return classes.join(' ');
  }

  @computed(`school.${CUSTOM_LINKS.map((link) => link.option).join(',')}`)
  get enabledCustomLinks() {
    return this.generateEnabledLinks(CUSTOM_LINKS);
  }

  @computed(
    `school.{heroPremierEnabled,${SOCIAL_LINKS.map((link) => link.option).join(',')}}`,
  )
  get enabledSocialLinks() {
    return this.generateEnabledLinks(SOCIAL_LINKS);
  }

  generateEnabledLinks(links) {
    if (isEmpty(this.school)) {
      return [];
    }
    return links.reduce((enabled, link) => {
      let href = this.get(`school.${link.option}`);
      if (!isEmpty(href)) {
        if (!href.includes('://') && !href.startsWith('mailto:')) {
          // Prepend a default protocol, as none was specified.
          // Assume HTTPS; if not supported, the school can fix their options.
          href = `https://${href}`;
        }
        enabled.push({
          label: link.label,
          href,
          icon: link.icon,
          customIcon: link.customIcon,
          image: link.image,
        });
      }
      return enabled;
    }, []);
  }
}
